import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { createUiBindings } from '@ff-scene-plugins/photo-prints-redux/slices/generalUiSlice';
import classNames from 'classnames';
import { magic_effects, standard_effects } from './components';
import { GridContainer, DraggableImageSquare } from './frames';
import styles from './FotofunPanel.module.scss';

export const MagicOptionTab = () => {
	const dispatch = useDispatch();

	const { t } = useTranslation();

    const [isMagicTab, setIsMagicTab] = useState(true);

	const { createUpdateAction } = createUiBindings();

	const setCanHaveBorderDraggedInto = createUpdateAction(
		'canHaveBorderDraggedInto'
	);

    const openMagicTab = () => {
        setIsMagicTab(true);
    };

    const openStandardTab = () => {
        setIsMagicTab(false);
    };

	const handleDragStart = () => {
		dispatch(setCanHaveBorderDraggedInto(true));
	};

	const handleDragEnd = () => {
		dispatch(setCanHaveBorderDraggedInto(false));
	};

    const frameTogglerClassName = classNames(styles.frameToggler, {
        [styles.magicActive]: isMagicTab
    });

    const framesSlideClassName = classNames(styles.framesSlideContainer, {
        [styles.magicActive]: isMagicTab,
        [styles.standardActive]: !isMagicTab
    });

    return (
        <>
            <div className={frameTogglerClassName}>
                <p className={`${styles.subtitle} ${styles.subtitleMagic}`} onClick={openMagicTab}>
                    {t('photo_prints.magic_frame_title')}
                </p>
                <p className={`${styles.subtitle} ${styles.subtitleStandard}`} onClick={openStandardTab}>
                    {t('photo_prints.standard_frame_title')}
                </p>
                <div className={styles.frameTogglerBottom}>
                    <div className={styles.activeBorder}></div>
                </div>
            </div>
            <div className={styles.framesSlideOverflowContainer}>
                <div className={framesSlideClassName}>
                    <div className={styles.frameSlide}>
                        <GridContainer className={styles.gridContainer}>
                            {magic_effects.map((effect) => (
                                <DraggableImageSquare
                                    key={effect.id}
                                    effect={effect}
                                    onDragStart={handleDragStart}
                                    onDragEnd={handleDragEnd}
                                />
                            ))}
                        </GridContainer>
                    </div>
                    <div className={styles.frameSlide}>
                        <GridContainer className={styles.gridContainer}>
                            {standard_effects.map((effect) => (
                                <DraggableImageSquare
                                    key={effect.id}
                                    effect={effect}
                                    onDragStart={handleDragStart}
                                    onDragEnd={handleDragEnd}
                                />
                            ))}
                        </GridContainer>
                    </div>
                </div>
            </div>
        </>
    );
};